var allOSB = [];
var osbMXH = '';

window.onload = function() {
    osbInit();
    $('#infoTabs a, .accordion-title').on('click', osbUpdateReadMore);
}

// Update on resize
window.onresize = function() {
    osbUpdateReadMore();
}

// init OSB
function osbInit() {
    // Set Variables
    allOSB = document.getElementsByClassName('only-so-big');

    if (allOSB.length > 0) {
        osbMXH = window.getComputedStyle(allOSB[0]).getPropertyValue('max-height');
        osbMXH = parseInt(osbMXH.replace('px', ''));

        // Add read-more button to each OSB section
        for (var i = 0; i < allOSB.length; i++) {
            var el = document.createElement('button');
            el.innerHTML = 'Skaitykite daugiau';
            el.setAttribute('type', 'button');
            el.setAttribute('class', 'btn btn-accent mt read-more hidden');

            osbInsertAfter(allOSB[i], el);
        }
    }

    // Add click function to buttons
    var readMoreButtons = document.getElementsByClassName('read-more');
    for (var i = 0; i < readMoreButtons.length; i++) {
        readMoreButtons[i].addEventListener('click', function() { 
            osbRevealThis(this);
        }, false);
    }

    // Update buttons so only the needed ones show
    osbUpdateReadMore();
}

// show only the necessary read-more buttons
function osbUpdateReadMore() {
    if (allOSB.length > 0) {
        for (var i = 0; i < allOSB.length; i++) {
            if (allOSB[i].scrollHeight > osbMXH) {
                if (allOSB[i].hasAttribute('style')) {
                    osbUpdateHeight(allOSB[i]);
                }
                allOSB[i].nextElementSibling.className = 'btn btn-accent mt read-more';
            } else {
                allOSB[i].nextElementSibling.className = 'btn btn-accent mt read-more hidden';
            }
        }
    }
}

function osbRevealThis(current) {
    var el = current.previousElementSibling;
    if (el.hasAttribute('style')) {
        current.innerHTML = 'Skaitykite daugiau';
        el.removeAttribute('style');
    } else {
        osbUpdateHeight(el);
        current.innerHTML = 'Rodyti mažiau';
    }
}

function osbUpdateHeight(el) {
    el.style.maxHeight = el.scrollHeight + 'px';
}

function osbInsertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}